import { render, staticRenderFns } from "./WHeaderCategory.vue?vue&type=template&id=49917a1f&scoped=true&"
import script from "./WHeaderCategory.vue?vue&type=script&lang=js&"
export * from "./WHeaderCategory.vue?vue&type=script&lang=js&"
import style0 from "./WHeaderCategory.vue?vue&type=style&index=0&id=49917a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49917a1f",
  null
  
)

export default component.exports